import { useState } from 'react'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { getProductQueryObject } from 'src/utils/amplitude/useProductObject'
import { CheckmarkOutlineIcon } from 'src/components/Icons/CheckmarkOutlineIcon'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import { useProductPageContext } from '../../contexts'

const UsefulnessSurvey = () => {
  const [sended, setSended] = useState(false)
  const { product, currentSku } = useProductPageContext()
  const { pageData } = useGlobalContext()

  const standardObject = getStandardObject(pageData)

  const productObject = getProductQueryObject(currentSku ?? product?.items[0])

  const handleOnClick = (response: string) => {
    const featuredObject = getFeatureObject({
      locationOnPage: 'pdp',
      section: 'feedback component',
      name: response,
    })

    dispatchAmplitudeEvent({
      eventName: 'Product Information Selected',
      eventData: {
        ...standardObject,
        ...featuredObject,
        'product details': [productObject],
        'information tab name': 'Feedback component',
      },
    })

    setSended(true)
  }

  return !sended ? (
    <div className="flex text-sm font-inter font-medium gap-6 px-4 py-3 justify-center bg-restructure-background-neutral-3">
      <p>Este conteúdo foi útil para você?</p>
      <button className="text-primaryBlue" onClick={() => handleOnClick('yes')}>
        Sim
      </button>
      <button className="text-primaryBlue" onClick={() => handleOnClick('no')}>
        Não
      </button>
    </div>
  ) : (
    <div className="flex text-sm font-inter font-medium gap-2 px-4 py-3 justify-center bg-restructure-background-neutral-3 text-textSuccess">
      <CheckmarkOutlineIcon /> <p>Obrigado, esportista!</p>
    </div>
  )
}

export default UsefulnessSurvey
